const COUNTRIES_SEPA_LENGTH = {
    AD: 24,
    AT: 20,
    BE: 16,
    BG: 22,
    CH: 21,
    CY: 28,
    CZ: 24,
    DE: 22,
    DK: 18,
    EE: 20,
    ES: 24,
    FI: 18,
    FR: 27,
    GB: 22,
    GI: 23,
    GR: 27,
    HR: 21,
    HU: 28,
    IE: 22,
    IS: 26,
    IT: 27,
    JE: 22,
    LI: 21,
    LT: 20,
    LU: 20,
    LV: 21,
    MC: 27,
    MT: 31,
    NL: 18,
    NO: 15,
    PL: 28,
    PT: 25,
    RO: 24,
    SE: 24,
    SI: 19,
    SK: 24,
    SM: 27,
    VA: 22,
}

export { COUNTRIES_SEPA_LENGTH };